// extracted by mini-css-extract-plugin
export default {"container":"LocaleButton_container__YVwb4"};